import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { publicApi } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Services() {
  const [items, setItems] = useState([]);

  useEffect(() => { publicApi.services().then(setItems).catch(() => setItems([])); }, []);

  return (
    <section id="servicios" className="relative py-24 md:py-36 border-t border-[#1A1A1A]/10 bg-[#F9F6F0]" data-testid="services-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end">
          <Reveal className="col-span-12 md:col-span-8">
            <div className="eyebrow mb-6">— 02 · Servicios</div>
            <h2 className="display-2">Soluciones <em className="italic text-[#1B3B2B]">adaptadas</em> a cada organización.</h2>
          </Reveal>
          <Reveal delay={0.15} className="col-span-12 md:col-span-4">
            <p className="text-[#4A4A4A] text-sm leading-relaxed">
              Nueve líneas de trabajo diseñadas para acompañar cada etapa: diagnóstico, implementación, auditoría, certificación y mejora continua.
            </p>
          </Reveal>
        </div>

        {/* Bento asymmetric grid */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-6 auto-rows-[minmax(180px,auto)] gap-[1px] bg-[#1A1A1A]/12 border border-[#1A1A1A]/12">
          {items.map((s, i) => {
            // Asymmetric bento pattern
            const layouts = [
              "md:col-span-3 md:row-span-2", "md:col-span-3", "md:col-span-3",
              "md:col-span-2", "md:col-span-2", "md:col-span-2",
              "md:col-span-4", "md:col-span-2", "md:col-span-6",
            ];
            return (
              <ServiceCell key={s.id} service={s} index={i} className={layouts[i] || ""} />
            );
          })}
        </div>
      </div>
    </section>
  );
}

function ServiceCell({ service, index, className }) {
  return (
    <motion.article
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ delay: index * 0.05, duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
      className={`group relative bg-[#F9F6F0] hover:bg-[#1B3B2B] transition-colors duration-500 p-6 md:p-8 flex flex-col ${className}`}
      data-testid={`service-card-${index}`}
    >
      <div className="flex items-start justify-between">
        <div className="chapter-num text-[2rem] group-hover:text-[#F9F6F0] transition-colors">
          {String(index + 1).padStart(2, "0")}
        </div>
        <div className="h-8 w-8 border border-[#1A1A1A]/15 rounded-full flex items-center justify-center group-hover:border-[#F9F6F0] group-hover:bg-[#F9F6F0] transition-colors">
          <ArrowUpRight className="w-3.5 h-3.5 group-hover:text-[#1B3B2B]" />
        </div>
      </div>
      <h3 className="mt-6 font-serif text-2xl md:text-3xl leading-tight text-[#1A1A1A] group-hover:text-[#F9F6F0] transition-colors">
        {service.titulo}
      </h3>
      <p className="mt-3 text-sm text-[#4A4A4A] leading-relaxed group-hover:text-[#F9F6F0]/85 transition-colors max-w-lg">
        {service.descripcion}
      </p>
      <div className="mt-auto pt-6">
        <Link
          to={`/servicios/${service.slug}`}
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A] group-hover:text-[#F9F6F0]"
          data-testid={`service-cta-${index}`}
        >
          Conocer el servicio <ArrowUpRight className="w-3 h-3" />
        </Link>
      </div>
    </motion.article>
  );
}
